import React, { useEffect, useState } from "react";
import {
  AdminNavigation,
  Title,
  Input,
  Button,
  Modal,
  MenuBar,
} from "../../../components";
// import styles from "./styles.module.css";
import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useToast, CircularProgress, Center } from "@chakra-ui/react";
import { FaWrench, FaTrashAlt } from "react-icons/fa";
import {
  addStageLevel,
  editStageLevel,
  fetchStagesLevel,
  removeStageLevel,
} from "../../../redux/actions/admin/stageLevelActions";
import {
  CREATE_STAGE_LEVEL_RESET,
  DELETE_STAGE_LEVEL_RESET,
  UPDATE_STAGE_LEVEL_RESET,
} from "../../../redux/constants/admin/stageLevelConstants";

const StageLevel = () => {
  const ptitle = "Stage Level";
  const dispatch = useDispatch();
  const toast = useToast();
  //   const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [stageLevelName, setStageLevelName] = useState("");
  const [id, setID] = useState(null);

  useEffect(() => {
    dispatch(fetchStagesLevel());
  }, [dispatch]);

  const openHandler = () => {
    setOpen(true);
    setEdit(false);
    setStageLevelName("");
  };

  // states
  const createStageLevel = useSelector((state) => state.createStageLevel);
  const { loading, error, success } = createStageLevel;
  const updateStageLevel = useSelector((state) => state.updateStageLevel);
  const {
    loading: uLoading,
    error: uError,
    success: uSuccess,
  } = updateStageLevel;
  const deleteStageLevel = useSelector((state) => state.deleteStageLevel);
  const {
    loading: dLoading,
    error: dError,
    success: dSuccess,
  } = deleteStageLevel;
  const getAllStagesLevel = useSelector((state) => state.getAllStagesLevel);
  const { stages = [] } = getAllStagesLevel;

  const columns = [{ title: "Stage Level", field: "stageLevelName" }];

  const deleteHandler = (id) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete this ${ptitle}`,
      icon: "warning",
      dangerMode: true,
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(removeStageLevel(id));
      }
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!stageLevelName) {
      toast({
        title: "Warning!",
        description: "Enter Name",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(addStageLevel(stageLevelName));
    }
  };

  const editHandler = (e) => {
    e.preventDefault();
    if (!stageLevelName) {
      toast({
        title: "Warning!",
        description: "Enter Name",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } else {
      dispatch(editStageLevel(stageLevelName, id));
    }
  };

  if (error || uError || dError) {
    toast({
      title: "Error",
      description: error || uError || dError,
      status: "error",
      duration: 9000,
      isClosable: true,
    });
    error && dispatch({ type: CREATE_STAGE_LEVEL_RESET });
    uError && dispatch({ type: UPDATE_STAGE_LEVEL_RESET });
    dError && dispatch({ type: DELETE_STAGE_LEVEL_RESET });
  }

  if (success || uSuccess || dSuccess) {
    toast({
      title: "Notification",
      description: `Sucesss`,
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    setOpen(false);
    dispatch(fetchStagesLevel());
    success && dispatch({ type: CREATE_STAGE_LEVEL_RESET });
    uSuccess && dispatch({ type: UPDATE_STAGE_LEVEL_RESET });
    dSuccess && dispatch({ type: DELETE_STAGE_LEVEL_RESET });
  }

  // Menubar Items
  const menu = [
    { name: "Helpdesk Teams", url: "/admin/config" },
    { name: "Ticket Type", url: "/admin/config/ticketType" },
    { name: "Stages", url: "/admin/config/stages" },
    { name: "Stage Level", url: "/admin/config/stagelevel", active: true },
    { name: "SLA Policies", url: "/admin/config/sla" },
    { name: "Priority", url: "/admin/config/priority" },
    { name: "Tag", url: "/admin/config/tag" },
    { name: "Exclude Stage", url: "/admin/config/excludeStage" },
  ];

  return (
    <div className="appContainer">
      <AdminNavigation />
      <div className="contentsRight">
        <Title title={ptitle} type="Admin" />
        <MenuBar menu={menu} />
        <div className="btnContainer right">
          <button type="button" onClick={openHandler} className="btn teal">
            Add {ptitle}
          </button>
        </div>
        {dLoading ? (
          <Center>
            <CircularProgress isIndeterminate color="#3AB29A" />
          </Center>
        ) : (
          <MaterialTable
            title=""
            columns={columns}
            data={stages}
            options={{
              exportAllData: true,
              exportButton: true,
              actionsCellStyle: {
                backgroundColor: "none",
                color: "#FF00dd",
              },
              actionsColumnIndex: -1,

              headerStyle: {
                backgroundColor: "#dcdcdc",
                color: "black",
                fontWeight: "bold",
              },
            }}
            style={{
              boxShadow: "none",
              width: "100%",
              background: "none",
              fontSize: "13px",
            }}
            actions={[
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Update",
                onClick: (event, rowData) => {
                  setOpen(true);
                  setEdit(true);
                  setStageLevelName(rowData.stageLevelName);
                  setID(rowData.id);
                },
                title: "Update",
                color: "teal",
                Icon: FaWrench,
              },
              {
                icon: "launch",
                iconProps: { style: { fontSize: "20px", color: "gold" } },
                tooltip: "Delete",
                onClick: (event, rowData) => {
                  deleteHandler(rowData.id);
                },
                title: "Delete",
                color: "gold",
                Icon: FaTrashAlt,
              },
            ]}
            components={{
              Action: (props) => (
                <button
                  onClick={(event) => props.action.onClick(event, props.data)}
                  className={`btnTable ${props.action.color}`}
                >
                  <props.action.Icon />
                  {props.action.title}
                </button>
              ),
            }}
          />
        )}
        <Modal
          isVisible={open}
          title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
          size="lg"
          content={
            <form onSubmit={edit ? editHandler : submitHandler}>
              <div className="nirsal__InputFlex">
                <Input
                  type="text"
                  onChange={(e) => setStageLevelName(e.target.value)}
                  value={stageLevelName}
                  required={true}
                  title="Stage Level Name"
                  size="large"
                />
                <Button
                  title={edit ? `Update ${ptitle}` : `Add ${ptitle}`}
                  type="submit"
                  isFullWidth={true}
                  size="lg"
                  loading={loading || uLoading}
                />
              </div>
            </form>
          }
          onClose={() => setOpen(false)}
        />
      </div>
    </div>
  );
};

export default StageLevel;
